import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

export interface TrackActionPageDetailsModel {
  platform: 'Web' | 'Android' | 'IOS'; // Web, Android, IOS
  screenSize: string;
  createdAt: number;
  sessionId: string; //userID
  location?: string; //Country code
  language?: string;
  age?: string;
  gender?: string;
  dataArray: TrackActionPageModel[];
}
export interface TrackActionPageModel {
  m: string; //travel_tour | car_rental
  c: string; // TOUR("T"), CAR("C")
  a: 'V' | 'C' | 'VI'; // VIEW("V"), CLICK("C"), VISIT("VI")
  d: string; // id tour | id car
  co: number; // count action
  l?: string; // empty string
  md?: null; // null
  mdCount?: null; // null
  lastCountTime?: number; // null
}
@Injectable({
  providedIn: 'root',
})
export class CollectUserEventSerVice {
  dataEvent: TrackActionPageDetailsModel;
  CAN_COUNT_AFTER: number = 60000; // 1 minute in milliseconds
  MAX_SIZE: number = 2048; // 2KB in bytes

  constructor(private http: HttpClient) {}
  getDataEvent(): TrackActionPageDetailsModel {
    return this.dataEvent;
  }

  initDataView(userId: string) {
    if (
      !localStorage.getItem(environment.PAGE_VIEW_DATA) ||
      localStorage.getItem(environment.PAGE_VIEW_DATA) === undefined ||
      localStorage.getItem(environment.PAGE_VIEW_DATA) === 'undefined'
    ) {
      this.dataEvent = {
        platform: 'Web',
        screenSize: `${window.innerWidth.toString()}x${window.innerHeight.toString()}`,
        createdAt: Date.now(),
        sessionId: userId,
        location: localStorage.getItem('currentCountryCode') ?? '',
        language: localStorage.getItem('lang') ?? '',
        dataArray: [],
      };
    } else {
      const localData = JSON.parse(localStorage.getItem(environment.PAGE_VIEW_DATA)!);
      this.dataEvent = localData;
      if (localData.sessionId !== userId) {
        this.postActionEvent().then(() => {
          this.dataEvent = {
            platform: 'Web',
            screenSize: `${window.innerWidth.toString()}x${window.innerHeight.toString()}`,
            createdAt: Date.now(),
            sessionId: userId,
            location: localStorage.getItem('currentCountryCode') ?? '',
            language: localStorage.getItem('lang') ?? '',
            dataArray: [],
          };
        });
      }
      localStorage.removeItem(environment.PAGE_VIEW_DATA);
    }
  }

  async collectActionEvent(tourId: string, action: 'V' | 'C' | 'VI' = 'V') {
    const existingEvent = this.dataEvent.dataArray.find(
      (event) => event.d === tourId && event.a === action
    );
    // Check if the event already exists
    if (existingEvent) {
      if (Date.now() - existingEvent?.lastCountTime! > environment.INTERVAL_COLLECT_DATA) {
        existingEvent.co += 1; // Increment the count
        existingEvent.lastCountTime = Date.now(); // Update the last count time
      }
    } else {
      await this.postActionEvent();
      const viewEvent: TrackActionPageModel = {
        m: 'travel_tour',
        c: 'T',
        a: action,
        co: 1,
        d: tourId,
        lastCountTime: Date.now(),
      };

      this.dataEvent.dataArray.push(viewEvent);
      const dataEventSize = new Blob([JSON.stringify(this.dataEvent)]).size;
      if (dataEventSize > this.MAX_SIZE) {
        this.postActionEvent();
      }
    }
  }
  async postActionEvent() {
    const url = `${environment.baseURL}/interaction-hub/interaction`;
    if (this.dataEvent.dataArray.length === 0) {
      return;
    }
    this.dataEvent.dataArray = this.dataEvent.dataArray.map((event) => {
      return {
        m: event.m,
        c: event.c,
        a: event.a,
        d: event.d,
        co: event.co,
      };
    });
    await this.http.post(url, this.dataEvent).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.dataEvent.dataArray = [];
          this.dataEvent.createdAt = Date.now();
        }
      },
      error: (error) => {
        console.error('Error posting event data:', error);
      },
    });
  }
}
